import createConnectWrappers from '4finance-connect-pl';
import * as passwordActions from './actions';
import { actions as translateActions } from '4finance-translate-pl';

var _createConnectWrapper = createConnectWrappers({
  actions: {
    passwordActions: passwordActions,
    translateActions: translateActions
  }
}),
    connectStateDecorator = _createConnectWrapper.connectState,
    connectActionsDecorator = _createConnectWrapper.connectActions;

export var connectState = connectStateDecorator;
export var connectActions = connectActionsDecorator;